import { render, staticRenderFns } from "./my-collection.vue?vue&type=template&id=cfce03b6&scoped=true&"
import script from "./my-collection.vue?vue&type=script&lang=js&"
export * from "./my-collection.vue?vue&type=script&lang=js&"
import style0 from "./my-collection.vue?vue&type=style&index=0&id=cfce03b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfce03b6",
  null
  
)

export default component.exports